import { ITirPmSvgStyleVars } from "./ITirPmSvgStyleVars";

export class TirPmSvgStyleVars implements ITirPmSvgStyleVars {
  "--tir-pm-svg__br" = "0.3333333333333333em";
  "--tir-pm-svg__padding" = "0.15em";
  "--tir-pm-svg__bg-layer-color" = "#fff";

  constructor(obj?: Partial<TirPmSvgStyleVars>) {
    if (obj) Object.assign(this, obj);
  }

  static setVars(vars: TirPmSvgStyleVars) {
    const styleElement = document.createElement("style");
    let varsStr = "";
    Object.keys(vars).forEach((key) => {
      varsStr += `${key}: ${vars[key as keyof TirPmSvgStyleVars]};\n`;
    });
    styleElement.textContent = `
  :root {
    ${varsStr}
  }
`;

    document.head.appendChild(styleElement);
  }
}
